/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ask_Update_Profile_After_FeedbackInputs */

const en_ask_update_profile_after_feedback = /** @type {(inputs: Ask_Update_Profile_After_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to add more data to your profile based on the feedback?`)
};

const de_ask_update_profile_after_feedback = /** @type {(inputs: Ask_Update_Profile_After_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchtest du auf Grundlage des Feedbacks weitere Daten in deinem Profil ergänzen?`)
};

/**
* | output |
* | --- |
* | "Would you like to add more data to your profile based on the feedback?" |
*
* @param {Ask_Update_Profile_After_FeedbackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ask_update_profile_after_feedback = /** @type {((inputs?: Ask_Update_Profile_After_FeedbackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ask_Update_Profile_After_FeedbackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ask_update_profile_after_feedback(inputs)
	return en_ask_update_profile_after_feedback(inputs)
});